import { deepEqual as equal } from 'fast-equals';
import React from 'react';

export default function PurifyComponent<P>(
  WrappedComponent: React.ComponentType<P>
): React.MemoExoticComponent<React.ComponentType<P>> {
  return React.memo(WrappedComponent, equal);
}
